<template>
  <div class="page" v-wechat-title="$route.meta.title='金牌讲解员'">
    <div class="station-top-bar border-box box">
      <div class="station-search-box flex" @click.stop="getFocus">
        <div class="station-search-bar border-box">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="">
          <input type="text" class="station-search-input"  placeholder="搜索内容" value="" v-model='inputValue' readonly />
          <!--<img class="station-input-close" src="../../assets/input-close.png" alt="" v-show="inputValue"  @click="inputValue=''">-->
        </div>
      </div>
    </div>

    <div class="tab-box border-box box">
      <div class="flex" data-cid="1" :class="cid==1?'curr':''" @click="toggleType(1)">人气推荐</div>
      <div class="flex" data-cid="18" :class="cid==18?'curr':''" @click="toggleType(18)">专业导游</div>
      <div class="flex" data-cid="19" :class="cid==19?'curr':''" @click="toggleType(19)">专家学者</div>
      <div class="flex" data-cid="20" :class="cid==20?'curr':''" @click="toggleType(20)">明星网红</div>
    </div>

    <div class="waterfall px-container clearfix">
      <ul v-if="newWaterfallData!=undefined" class="fl px-waterfall border-box" v-for="(el,ind) in newWaterfallData" :key="ind">
        <li class="border-box" v-for="(item,index) in el" :key="index" @click="goGuideInfo(item.id)">
          <div class="clearfix" style="position: relative;">
            <div class="icon-tx clearfix" v-if="item.headimg">
              <img v-lazy="item.headimg" :key="item.id" alt="" >
              <!--<span class="guide-tag" v-if="item.guidetag">{{item.guidetag}}</span>-->
            </div>
            <div class="fl bottom-box border-box">
              <div class="bag-name" v-if="item.guidetag">{{item.guidetag}}</div>
              <div class="guide-name clearfix hide">
                <span class="fl name hide">{{item.name}}</span>
                <span class="fr num"><img src="../../assets/icon_09.png" alt="">{{item.listen|initNumber}}收听</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <p class="load-tip" ref="loadtip">{{loadText}}</p>


    <div class="search-page" v-show="searchShow==1">
      <div class="search-box">
        <form class="search-form border-box" v-on:submit.prevent="search">
          <span @click.stop="searchShow=0"><img src="../../assets/icon_28.png" alt=""></span>
          <input type="search" placeholder="搜索讲解员" v-model='inputValue'  ref="searchInp"  id="searchInp" />
          <div @click.stop='search' v-if="searchList.length<=0||inputValue==''">搜索</div>
          <div style="color:#ff5767;" @click.stop="searchList=[],inputValue=''" v-else>取消</div>
        </form>
      </div>
      <div class="search-scoll" id="scollBox">
        <div class="search-list">
          <div class="search-li" :class="item.type=='spot'?'search-li1':''" v-for="(item,index) in searchList" :key="index" @click="selectSearch(index)">
            <div v-html="initTxt(item.name)"></div>
            <p v-if="item.type=='spot'"><font v-html="initTxt(item.name)"></font></p>
          </div>
        </div>
        <p v-show="searchList.length>0" class="load-tip load-tip1" id="loadTip" style="height: auto;">{{loadText1}}</p>
      </div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>

<script>
  import P400 from '../../components/P400'
  import {getGuide} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore,scollLoadMore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        siteid: '', //站点id
        userInfo: {}, //用户信息
        latlng: {}, //经纬度信息
        cityInfo: {}, //城市信息
        bagList:[],//语音列表
        searchList:[],//搜索列表
        total: '',//导游总数
        searchTotal:'',//弹窗导游总数
        inputValue: '',//搜索关键词
        page: 1,
        pageAlert:1,//弹窗内分页 page
        rowsAlert:15,//弹窗内分页 rows
        rows: 10,
        loadText: "数据加载中",
        loadText1: '', //弹窗列表提示
        cid:1,
        TimeStamp: new Date().getTime(),  //获取当前时间
        newWaterfallData: '',
        waterfallDataNumber:'',
        appKey:'',
        appKeyA: '',
        searchShow: 0, //是否显示搜索窗
        searchFocus:false,
        searchTip:0,

        P400: 0, //系统维护中
      }
    },
    computed: {},
    beforeRouteLeave (to, from, next) {
      window.removeEventListener("scroll",this.handleFun);
      from.meta.keepAlive = true;
      next();
    },
    created() {
      let self = this;

      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.inputValue = this.$route.query.inputValue.replace(/(^\s*)|(\s*$)/g, "") || "";
      this.userInfo = getStore("userInfo");
      this.sregion = getStore("sregion") || '';
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      let cityInfo = getStore("cityInfo");
      if(cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""  ){
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          self.initData(self.page,self.cid);
        });
      }else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function(res){
          self.latlng ={ lat: res.latitude, lng: res.longitude };
          self.initData(self.page,self.cid);
        });
      }

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
      document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
    },
    activated(){
      window.addEventListener("scroll",this.handleFun);
    },
    methods: {
      //获取语音+景区+推荐信息
      async initData(page,cid){
        let res = await getGuide({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode,
          page: page,
          rows: this.rows,
          cid:cid,
          name: '', //搜索关键词
          sregion: this.sregion,
          openid: this.userInfo.openid,
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.total = res.data.total;
          let bagList = res.data.baglist;
          if (page >= Math.ceil(this.total / this.rows) || bagList.length >= this.total) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (bagList.length > 0) {
            this.bagList = [...this.bagList, ...bagList];
            let [ ...waterfallData ]  = this.bagList;
            let [ ...newWaterfallData ]= [[],[]];
            this.bagList.forEach((el,i) => {
              switch( i%2 ) {
              case 0 : newWaterfallData[0].push(el)
                break
              case 1: newWaterfallData[1].push(el)
                break
              }
            });
            this.newWaterfallData = [newWaterfallData[0],newWaterfallData[1]]
          } else {
            if (page == 1) {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
              this.bagList = [];
              this.newWaterfallData = [[],[]];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”，一起来听景区故事吧';
          let link = '/waterfall?siteid='+ this.siteid +'&TimeStamp='+ this.TimeStamp +'&inputValue='+ this.inputValue+'&appKey='+(this.appKey);
          wxShareme(title,desc,"",link);

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },

      //获取搜索内容信息
      async initSearchData(page){
        let res = await getGuide({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode,
          page: page,
          rows: this.rowsAlert,
          cid:'',
          name: this.inputValue, //搜索关键词
          sregion: this.sregion,
          openid: this.userInfo.openid,
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.searchTip = 1;
          this.searchTotal = res.data.total;
          let searchList = res.data.baglist;
          console.log(page,this.searchTotal,this.rowsAlert,page >= Math.ceil(this.searchTotal / this.rowsAlert));
          if (page >= Math.ceil(this.searchTotal / this.rowsAlert)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (searchList.length > 0) {
            this.searchList = [...this.searchList, ...searchList];
          } else {
            if (page == 1) {
              this.searchList = [];
//              this.loadText1 = '暂无数据'
              this.$toast('暂无搜索结果');
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }else {
          this.$toast(res.errmsg)
          this.$router.push({
            path: `/400?${'appKey=' + this.appKey}`
          });
        }

      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page,self.cid);
          });
        })
      },

      handleFun1: function (){
        let self = this;
        self.$nextTick(function() {
          scollLoadMore(self,'scollBox','loadTip',function(){
            self.pageAlert += 1;
            self.initSearchData(self.pageAlert);
          });
        })
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if(this.inputValue == ''){
          this.$toast('请输入搜索关键词');
          return;
        }
        this.$loading.show('数据加载中');
        this.pageAlert = 1;
        this.searchList = [];
        this.initSearchData(this.pageAlert)
      },

      //选择搜索结果
      selectSearch: function(index){
        this.goGuideInfo(this.searchList[index].id)
        this.searchShow = 0;
      },

      //标注搜索结果
      initTxt: function (txt){
        return txt.replace(this.inputValue, '<span style="color: #ff8a00">'+ this.inputValue + '</span>')
      },


      getFocus(){
        this.searchShow=1;
        this.searchList=[];
        this.$nextTick( () =>{
          this.$refs.searchInp.focus()
        } )
      },



      //切换筛选内容
      toggleType(cid){
        this.$loading.show('数据加载中');
        this.cid = cid;
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.bagList = [];
        this.initData(1,cid);
      },

      //跳转到专辑详情页
      goGuideInfo(id){
        this.$router.push({
          path: `/guide-info?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

    },

    watch:  {
      searchShow(newVal,oldVal){
        if(newVal == 1 ){
          document.getElementById("scollBox").addEventListener("scroll",this.handleFun1)
        }else {
          document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
        }
      }
    },

    components: {
      P400,
    },

    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .tab-box{position:fixed;top:1rem;left:0;right:0;z-index:1;padding: 0 .21rem .12rem;background: #fff;}
  .tab-box .flex{height:.6rem;line-height:.58rem;margin-right: .15rem;text-align:center;font-size:.26rem;color:#555;border-radius: .08rem;border: 1px solid #f2f2f2;background: #f2f2f2;}
  .tab-box .flex:last-child{margin-right: 0;}
  .tab-box .flex.curr{color: #f7ad0d;border-color: #f7ad0d;}
  .px-container { width: 100%;padding-top: 1.78rem; }
  .px-waterfall { width: 50%;}
  .px-waterfall img.bg-img {border-radius: 8px; }
  .icon-tx {position:relative;width: 100%;height: auto; border-radius: .08rem .08rem 0 0;}
  .icon-tx img {float: left;width: 100%;height: auto;border-radius: .08rem .08rem 0 0;}
  .guide-tag{position: absolute;left: .15rem;top: .12rem;font: bold .24rem "Microsoft YaHei";color: #fff;text-shadow: 0 0 .04rem #2b7fda;}
  .px-waterfall:first-child{padding: 0 .16rem 0 .24rem}
  .px-waterfall:last-child{padding: 0 .24rem 0 .16rem}
  .px-waterfall li{ margin-bottom: .36rem;background: #fff;border-radius: .08rem;box-shadow: 0 0 0.25rem #f5f5f5;overflow: hidden;}
  .bottom-box{width: 100%;padding: .2rem;}
  .guide-name{font: .24rem/.4rem "Microsoft YaHei";color: #686868;}
  .guide-name span.name{max-width:55%;}
  .guide-name span.num{font: .2rem/.4rem "Microsoft YaHei";color: #666;}
  .guide-name span.num img{float: left;width: auto;height: .2rem;margin-top: .1rem;margin-right: .05rem;}
  .bag-name{margin-bottom:.12rem;font:bold .28rem/.36rem "Microsoft YaHei";color: #000;}

  /*搜索页面*/
  .search-page{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 10; background-color: #edefed;}
  .search-box{ padding-top: .12rem; padding-bottom: .19rem; }
  .search-form{ position: relative; display: block; padding: .16rem 1.2rem .16rem .72rem; height: 1rem; background-color: #fff; }
  .search-form span{ position: absolute; left: 0; top: .16rem; width: .72rem; height: .68rem; }
  .search-form span img{ width: .16rem; height: .29rem; margin: .2rem 0 0 .3rem }
  .search-form div{ position: absolute; right: 0; top: .16rem; width: 1.2rem; height: .68rem; line-height: .68rem; font-size: .3rem; color: #333; text-align: center; }
  .search-form input{ display: block; padding: .09rem .25rem; width: 100%; height: .68rem; line-height: .68rem; font-size: .26rem; color: #333; background-color: #f5f5f5; border-radius: .12rem; overflow: hidden; }
  .search-scoll{ width: 100%; position: absolute;top: 1.31rem;bottom: 0;left: 0;width: 100%;overflow-y: scroll; background-color: #fff; }
  .search-list{padding: 0 .32rem 0 .26rem; }
  .search-li{ position: relative;}
  .search-li img{ position: absolute; left: 0; top: .3rem; width: .28rem; height: .34rem; }
  .search-li div{ padding: .3rem 0 .26rem; width: 100%; height: .34rem; line-height: .34rem; font-size: .26rem; color: #666; border-bottom: .01rem solid #e5e5e5; }
  .search-li1 div{ padding: .2rem 0 .08rem; border-bottom: 0; }
  .search-li1 img{ left: .01rem; top: .32rem; height: .28rem; }
  .search-li p{ padding-bottom: .2rem; line-height: .2rem; font-size: .18rem; color: #b2b2b2; border-bottom: .01rem solid #e5e5e5; }
  .search-li span{ font-weight: normal; color: #ff8a00; }
</style>



// WEBPACK FOOTER //
// src/page/waterfall/waterfall.vue